import SendBird from 'sendbird';
import { uuid4 } from '@/scripts/utils';

class SendBirdEvent {
  constructor() {
    this.sb = SendBird.getInstance();
    this.key = uuid4();
    this._createChannelHandler();

    this.onMessageReceived = null;
    this.onMessageUpdated = null;
    this.onMessageDeleted = null;

    this.onChannelChanged = null;
    this.onChannelParticipantCountChanged = null;
    this.onUserEntered = null;
    this.onUserJoined = null;
    this.onUserLeft = null;
    this.onChannelHidden = null;
  }

  _createChannelHandler() {
    const handler = new this.sb.ChannelHandler();
    handler.onMessageReceived = (channel, message) => {
      if (this.onMessageReceived) {
        this.onMessageReceived(channel, message);
      }
    };
    handler.onMessageUpdated = (channel, message) => {
      if (this.onMessageUpdated) {
        this.onMessageUpdated(channel, message);
      }
    };
    handler.onMessageDeleted = (channel, messageId) => {
      if (this.onMessageDeleted) {
        this.onMessageDeleted(channel, messageId);
      }
    };
    handler.onChannelChanged = channel => {
      if (this.onChannelChanged) {
        this.onChannelChanged(channel);
      }
    };
    handler.onChannelParticipantCountChanged = channel => {
      if (this.onChannelParticipantCountChanged) {
        this.onChannelParticipantCountChanged(channel);
      }
    };
    handler.onUserEntered = (openChannel, user) => {
      if (this.onUserEntered) {
        this.onUserEntered(openChannel, user);
      }
    };
    handler.onUserJoined = (groupChannel, user) => {
      if (this.onUserJoined) {
        this.onUserJoined(groupChannel, user);
      }
    };
    handler.onUserLeft = (groupChannel, user) => {
      if (this.onUserLeft) {
        this.onUserLeft(groupChannel, user);
      }
    };
    handler.onChannelHidden = groupChannel => {
      if (this.onChannelHidden) {
        this.onChannelHidden(groupChannel);
      }
    };
    this.sb.addChannelHandler(this.key, handler);
  }

  remove() {
    this.sb.removeChannelHandler(this.key);
  }
}

export default SendBirdEvent;
